import isObject from 'lodash-es/isObject';
import isEqual from 'lodash-es/isEqual';
import transform from 'lodash-es/transform';

export function deleteEmptyProperties<T>(object: T): void {
    Object.keys(object)
        .filter(key => object[key] === null || object[key] === undefined || !object[key])
        .forEach(key => delete object[key]);
}

export function deleteEmptyPropertiesFromFilters<T>(object: T): void {
    Object.keys(object)
        .filter(key => !object[key] && object[key] !== false && object[key] !== 0)
        .forEach(key => delete object[key]);
}

export function recursiveDeleteEmptyProperties<T>(object: T): void {
    if (object === null || object === undefined) {
        return;
    }

    Object.keys(object).forEach(key => {
        if (typeof object[key] === 'object') {
            recursiveDeleteEmptyProperties(object[key]);
            return;
        }
    });

    deleteEmptyProperties(object);
}

export function recursiveDeleteEmptyPropertiesFromFilters<T>(object: T): void {
    if (object === null || object === undefined) {
        return;
    }

    Object.keys(object).forEach(key => {
        if (typeof object[key] === 'object') {
            recursiveDeleteEmptyProperties(object[key]);
            return;
        }
    });

    deleteEmptyPropertiesFromFilters(object);
}

export function isEmpty(obj: Record<string, any>, params = {withFalseValue: false}): boolean {
    if (isObject(obj)) {
        return Object.keys(obj).every(k => isEmpty(obj[k], params));
    } else {
        return obj === null || obj === '' || obj === undefined || (params.withFalseValue && obj === false);
    }
}

/**
 * Deep diff between two objects, using lodash
 */
export function objectDiff(object, base): any {
    return transform(object, (result, value, key) => {
        if (!isEqual(value, base[key])) {
            result[key] = isObject(value) && isObject(base[key]) ? objectDiff(value, base[key]) : value;
        }
    });
}
